// SHOP GALLERY
const shopGalleryThumbs = document.querySelectorAll(
  ".hoox-shop__gallery-thumbs .swiper-slide"
);

if (shopGalleryThumbs.length > 0) {
  var galleryThumbs = new Swiper(".swiper-thumbs", {
    slidesPerView: 5,
    loop: false,
    spaceBetween: 10,
    watchSlidesProgress: true,

    breakpoints: {
      768: {
        spaceBetween: 8,
      },
    },
  });

  var galleryTop = new Swiper(".hoox-shop__gallery-main", {
    slidesPerView: 1,
    loop: true,

    thumbs: {
      swiper: galleryThumbs,
    },
  });
}

// POPUP TOGGLE
const popupTriggers = document.querySelectorAll(".js-popup-trigger");
const popup = document.querySelector(".hoox-shop-popup");
const html = document.querySelector("html");

if (popup) {
  popupTriggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      popup.classList.toggle("active");
      html.classList.toggle("no-scroll");
    });
  });
}

// POPUP TABS
const shopTabs = document.querySelectorAll(".hoox-shop-popup__tab");
const popupPanels = document.querySelectorAll(".hoox-shop-popup__panel");

if (!!shopTabs.length && !!popupPanels.length) {
  shopTabs[0].classList.add("active");
  popupPanels[0].classList.add("active");

  shopTabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      setActive(tab);
    });
  });

  const showPanels = (tab) => {
    tab.addEventListener("click", () => {
      let tabIndex = tab.getAttribute("data-tab");
      let panels = document.querySelectorAll(".hoox-shop-popup__panel");

      panels.forEach((panel) => {
        const panelIndex = panel.getAttribute("data-panel");
        if (panelIndex === tabIndex) {
          setActive(panel);
        }
      });
    });
  };

  const setActive = function (el) {
    [...el.parentElement.children].forEach(function (sib) {
      sib.classList.remove("active");
    });
    el.classList.add("active");
  };

  shopTabs.forEach((tab) => {
    showPanels(tab);
  });
}

shopStickyBar();
//Sticky cta logic
function shopStickyBar() {

  var classActive = "sticky";
  var element = document.querySelector(
    ".hoox-shop__product-form .prod-form__actions"
  );
  var isInViewport = function (elem) {
    var rect = elem.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  var debounce = function (func, delay) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, delay);
    };
  };
  var handleScroll = function () {
    var targetSections = [
      document.querySelector(".footer"),
      document.querySelector(".hoox-footer"),
      document.querySelector(".hoox-shop"),
    ];

    var isAnySectionInView = targetSections.some(function (section) {
      return section && isInViewport(section);
    });

    if (isAnySectionInView) {
      element.classList.remove(classActive);
    } else {
      element.classList.add(classActive);
    }
  };
  var debouncedScroll = debounce(handleScroll, 50); // Adjust the debounce delay as needed
  window.addEventListener("scroll", debouncedScroll);
}

//Hoox product form
const hooxShopProductForm = document.querySelector(".hoox-shop__product-form");

//Subscribe boxes click handle
const boxes = hooxShopProductForm.querySelectorAll(
  ".skio-frequency .input-pill"
);

if (!!boxes.length) {
  boxes[0].classList.add("active");

// Add click event listeners to each box
  boxes.forEach((box) => {
    box.addEventListener("click", () => {
      // Remove "active" class from all boxes
      boxes.forEach((otherBox) => {
        otherBox.classList.remove("active");
      });

      // Add "active" class to the clicked box
      box.classList.add("active");
    });
  });
}

//Price update on change
const hooxShopAtcButtonPrice = hooxShopProductForm.querySelector(
  ".hoox-shop__atc-price"
);
const checkedRadioButton = hooxShopProductForm.querySelector(
  'input[type="radio"]:checked'
);
const initialCheckedPrice =
        checkedRadioButton?.nextElementSibling.querySelector(".skio-price");

if (hooxShopAtcButtonPrice && initialCheckedPrice) {
  hooxShopAtcButtonPrice.textContent = initialCheckedPrice.textContent;
}

const skioPrices = hooxShopProductForm.querySelectorAll(".skio-price");
if (!!skioPrices.length) {
  skioPrices.forEach((price) => {
    const priceValue = price.textContent;

    const skioInput = price
      .closest(".skio-group-container")
      .querySelector("input");
    skioInput.addEventListener("click", () => {
      if (hooxShopAtcButtonPrice) {
        hooxShopAtcButtonPrice.textContent = priceValue;
      }
    });
  });
}
